var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#000","strokeMiterlimit":"10","transform":"translate(11.314 -12.728) rotate(45)","d":"m9 17h16m-8-8v16"}));
}

Cross.defaultProps = {"viewBox":"0 0 22.627 22.627","focusable":"true"};

module.exports = Cross;

Cross.default = Cross;
